import { render, staticRenderFns } from "./BotonesAcuerdoImpreion.vue?vue&type=template&id=44bb8f34&"
import script from "./BotonesAcuerdoImpreion.vue?vue&type=script&lang=js&"
export * from "./BotonesAcuerdoImpreion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports